export default "__VITE_PUBLIC_ASSET__be98a4e7__"